import React, { useState, useEffect } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Axios from 'axios';
import config, { environment } from '../config';
import XXVICall from '../Assets/Docs/XXVI-ik SZEKELYFOLDI Geologus  Találkozó – Nyárádszereda.pdf';

const meetingsData = [
  { number: 'XXVI.', year: 2026, date: 'október 22-25', location: 'Nyárádszereda' },
];

function UpcomingMeetingBanner() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  
  const now = new Date();

  const isPastMeeting = (meeting) => {
    if (!meeting.year) return true;
    if (meeting.year < now.getFullYear()) return true;
    if (meeting.year > now.getFullYear()) return false;
    
    if (meeting.year === 2026 && meeting.date.includes('okt')) {
        const meetingMonth = 9; // October
        if (now.getMonth() < meetingMonth) return false;
        const dayMatch = meeting.date.match(/(\d+)/);
        if (dayMatch) {
            const startDay = parseInt(dayMatch[1]);
            if (now.getMonth() === meetingMonth && now.getDate() < startDay) return false;
        }
    }
    return true;
  };

  useEffect(() => {
    async function fetchMeetings() {
      try {
        const response = await Axios.get(config[environment].meetingsEndpoint);
        let meetings = [];
        if (response.data && response.data.length > 0) {
          meetings = response.data;
        } else {
          meetings = meetingsData;
        }
        const future = meetings.filter(m => !isPastMeeting(m));
        setUpcomingMeetings(future);
      } catch (error) {
        console.error("Error fetching meetings for banner:", error);
        const future = meetingsData.filter(m => !isPastMeeting(m));
        setUpcomingMeetings(future);
      }
    }
    fetchMeetings();
  }, []);

  if (upcomingMeetings.length === 0) return null;

  const bannerText = upcomingMeetings.map(m => {
    const yearDisplay = i18n.language.startsWith('hu') ? `${m.year}.` : m.year;
    return `${m.number} ${t('SZGT.Title')}: ${m.location}, ${yearDisplay} ${m.date}`;
  }).join('  |  ');

  const handleBannerClick = (e) => {
    // If user clicked the link specifically, don't navigate the whole box
    if (e.target.tagName === 'A') return;
    navigate(`/${i18n.language}/talalkozo`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'accent.oliveGreen',
        color: 'white',
        py: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        cursor: 'pointer',
        '&:hover .marquee': {
          animationPlayState: 'paused',
        },
      }}
      onClick={handleBannerClick}
    >
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee {
            display: inline-block;
            animation: marquee 40s linear infinite;
          }
          .marquee-item {
            display: inline-flex;
            align-items: center;
          }
          .call-link {
            color: #ffeb3b;
            margin-left: 20px;
            margin-right: 20px;
            text-decoration: underline;
            font-weight: bold;
          }
        `}
      </style>
      <Box className="marquee">
        <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 'bold',
              fontSize: '1.1rem',
              display: 'inline-flex',
              alignItems: 'center',
            }}
        >
            <span className="marquee-item">
                {bannerText} — {t('SZGT.UpcomingPromo')}
                <Link href={XXVICall} target="_blank" rel="noopener noreferrer" className="call-link">
                    {t('SZGT.DownloadCall')}
                </Link>
            </span>
            <span className="marquee-item">
                {bannerText} — {t('SZGT.UpcomingPromo')}
                <Link href={XXVICall} target="_blank" rel="noopener noreferrer" className="call-link">
                    {t('SZGT.DownloadCall')}
                </Link>
                &nbsp;
            </span>
        </Typography>
      </Box>
    </Box>
  );
}

export default UpcomingMeetingBanner;
